module.exports = __webpack_public_path__ + "static/media/PAENT_MENU-normal.eedd5e8a.png";